export enum PaperlessAgencyStatus {
    yes = 'yes',
    no = 'no',
    partial = 'partial',
}

export const PaperlessAgencyStatusLabels: Record<PaperlessAgencyStatus, string> = {
    [PaperlessAgencyStatus.yes]: 'Yes',
    [PaperlessAgencyStatus.no]: 'No',
    [PaperlessAgencyStatus.partial]: 'Partial – Working towards paperless',
};

export const getAllPaperlessAgencyStatuses = () => {
    return Object.values(PaperlessAgencyStatus).map((value) => ({
        value,
        label: PaperlessAgencyStatusLabels[value],
    }));
};
